module.exports = __webpack_public_path__ + "static/img/96.27a9a2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/96.png
// module id = lzfr
// module chunks = 0